
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as QRCode from 'qrcode';

@Component
export default class QrCode extends Vue {
  @Prop({ required: true })
  content!: string;
  @Prop({ default: 128 })
  size!: number;

  dataUrl: string = '';

  @Watch('content', { immediate: true }) //trigger on initial change as well
  onContentChange(): void {
    QRCode.toDataURL(this.content, { errorCorrectionLevel: 'L', width: this.size }, (err: any, url: string) => {
      if (err) {
        return console.error(err);
      }
      this.dataUrl = url;
    });
  }
}
